(() => {
  function run(root) {
    root.querySelectorAll('script[data-theme-deferred]:not([data-executed])').forEach(source => {
      source.dataset.executed = 'true';
      const script = document.createElement('script');
      if (source.nonce) script.nonce = source.nonce;
      script.textContent = source.textContent;
      source.after(script);
    });
  }
  function sizeImages(root) {
    root.querySelectorAll('img[data-intrinsic-size]').forEach(image => {
      const size = () => {
        if (!Number(image.getAttribute('width')) && image.naturalWidth) {
          image.setAttribute('width', image.naturalWidth);
          image.setAttribute('height', image.naturalHeight);
        }
      };
      if (image.complete) size(); else image.addEventListener('load', size, {once: true});
    });
  }
  run(document);
  sizeImages(document);
  document.addEventListener('shopify:section:load', event => sizeImages(event.target));
  document.addEventListener('shopify:section:load', event => run(event.target));
})();
/* SEO conversion signals shared by the engineering and recruiting layouts. */
(function () {
  'use strict';

  // The verified historical property is primary; retain the other property's history.
  var destinations = ['G-7E2EL8XVSX'];
  var sent = Object.create(null);
  var attributionKey = 'outerReefAttribution';

  function clean(value, limit) {
    return String(value || '')
      .replace(/[^a-zA-Z0-9 _./:+-]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, limit || 120);
  }

  function readAttribution() {
    var existing = {};
    try { existing = JSON.parse(window.sessionStorage.getItem(attributionKey) || '{}'); } catch (error) { existing = {}; }
    var query = new URLSearchParams(window.location.search);
    var values = {
      landing_page: clean(existing.landing_page || window.location.pathname, 200),
      initial_referrer: clean(existing.initial_referrer || document.referrer, 300),
      utm_source: clean(existing.utm_source || query.get('utm_source'), 100),
      utm_medium: clean(existing.utm_medium || query.get('utm_medium'), 100),
      utm_campaign: clean(existing.utm_campaign || query.get('utm_campaign'), 150),
      utm_content: clean(existing.utm_content || query.get('utm_content'), 150),
      utm_term: clean(existing.utm_term || query.get('utm_term'), 150)
    };
    try { window.sessionStorage.setItem(attributionKey, JSON.stringify(values)); } catch (error) { /* Storage can be disabled. */ }
    return values;
  }

  function serviceLine() {
    var path = window.location.pathname.toLowerCase();
    if (document.body.classList.contains('recruiting-site') || /\/pages\/recruiting/.test(path)) return 'recruiting';
    if (/(motor|bldc|brushless|field-oriented|foc|commutation)/.test(path)) return 'bldc';
    return 'engineering';
  }

  function recruitingAudience() {
    var path = window.location.pathname.toLowerCase();
    if (path.indexOf('employer') !== -1) return 'employer';
    if (path.indexOf('candidate') !== -1) return 'candidate';
    return 'general';
  }

  function leadType() {
    if (serviceLine() !== 'recruiting') return 'engineering';
    return recruitingAudience() === 'candidate' ? 'recruiting_candidate' : 'recruiting_employer';
  }

  function acquisitionSource(values) {
    if (values.utm_source) return values.utm_source;
    if (!values.initial_referrer) return 'direct';
    try { return new URL(values.initial_referrer).hostname.replace(/^www\./, ''); }
    catch (error) { return 'referral'; }
  }

  function acquisitionMedium(values) {
    if (values.utm_medium) return values.utm_medium;
    var source = acquisitionSource(values);
    if (/^(?:google|bing|search\.yahoo)\./i.test(source)) return 'organic';
    return source === 'direct' ? 'direct' : 'referral';
  }

  function sendOnce(eventName, key, parameters) {
    var eventKey = eventName + ':' + key;
    if (sent[eventKey]) return;
    sent[eventKey] = true;

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('event', eventName, Object.assign({
      send_to: destinations,
      page_location: window.location.href,
      page_path: window.location.pathname
    }, parameters || {}));
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    var label = (link.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 100);

    if (/^tel:/i.test(href)) {
      sendOnce('phone_click', href, {
        link_url: href,
        link_text: label,
        page_type: document.body.classList.contains('recruiting-site') ? 'recruiting' : 'engineering'
      });
    }

    if (/calendly\.com/i.test(href)) {
      sendOnce('schedule_click', href, {
        link_url: link.href,
        link_text: label,
        service_line: serviceLine()
      });
    }

    if (document.body.classList.contains('recruiting-site') && link.closest('main')) {
      var isRecruitingAction = /recruiting-(?:employers|candidates)|request-for-quote|contact|mailto:|calendly\.com/i.test(href);
      if (isRecruitingAction) {
        sendOnce('recruiting_cta_click', href + ':' + label, {
          link_url: link.href,
          link_text: label,
          recruiting_page: window.location.pathname
        });
      }
    }
  }, true);

  var attribution = readAttribution();
  var fieldNames = {
    landing_page: 'Landing page',
    initial_referrer: 'Initial referrer',
    utm_source: 'UTM source',
    utm_medium: 'UTM medium',
    utm_campaign: 'UTM campaign',
    utm_content: 'UTM content',
    utm_term: 'UTM term'
  };

  document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
    Object.keys(fieldNames).forEach(function (key) {
      if (!attribution[key] || form.querySelector('[data-attribution-field="' + key + '"]')) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'contact[' + fieldNames[key] + ']';
      input.value = attribution[key];
      input.setAttribute('data-attribution-field', key);
      form.appendChild(input);
    });

    // Hidden fields are retained in Shopify's inquiry email. HubSpot's automatic
    // collector does not read them; the native Forms API below maps them explicitly.
    var hubspotFields = {
      original_landing_page: attribution.landing_page,
      original_source: acquisitionSource(attribution),
      original_medium: acquisitionMedium(attribution),
      original_campaign: attribution.utm_campaign,
      service_line: serviceLine() === 'recruiting' ? 'recruiting' : serviceLine() === 'bldc' ? 'bldc_motor_control' : 'other_engineering',
      lead_type: leadType()
    };
    Object.keys(hubspotFields).forEach(function (key) {
      if (!hubspotFields[key] || form.querySelector('[data-hubspot-attribution="' + key + '"]')) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = clean(hubspotFields[key], 200);
      input.setAttribute('data-hubspot-attribution', key);
      form.appendChild(input);
    });

    form.addEventListener('submit', function () {
      if (!form.checkValidity()) return;
      var email = form.querySelector('[name="contact[email]"]');
      var name = form.querySelector('[name="contact[name]"]');
      if (!email || !email.value.trim()) return;
      var fields = Object.assign({}, hubspotFields, { email: email.value.trim().slice(0, 254) });
      if (name && name.value.trim()) {
        var parts = name.value.trim().split(/\s+/);
        fields.firstname = parts.shift().slice(0, 80);
        if (parts.length) fields.lastname = parts.join(' ').slice(0, 80);
      }
      [['company', 'company', 120], ['phone', 'phone', 40], ['body', 'message', 2000]].forEach(function (mapping) {
        var field = form.querySelector('[name="contact[' + mapping[0] + ']"]');
        if (field && field.value.trim()) fields[mapping[1]] = field.value.trim().slice(0, mapping[2]);
      });
      // Retain this inquiry only in its browser tab across the Shopify redirect,
      // for at most 30 minutes; erase it after HubSpot accepts it. Never attach a
      // concierge transcript or include these contact details in analytics.
      try { window.sessionStorage.setItem('outerReefPendingInquiry', JSON.stringify({
        at: Date.now(), path: window.location.pathname, fields: fields
      })); } catch (error) { /* Shopify still delivers the inquiry normally. */ }
    });
  });

  // These markers are rendered only inside Liquid's form.posted_successfully?
  // branch. A query string or a validation error must never count as a lead.
  var contactSucceeded = Boolean(document.querySelector('form[action*="/contact"] .corp-form-status, form[action*="/contact"] .contact-intake__success, form.rm-form[action*="/contact"] > [role="status"]'));
  var pending = null;
  try { pending = JSON.parse(window.sessionStorage.getItem('outerReefPendingInquiry') || 'null'); } catch (error) { /* No stored submission. */ }
  if (pending && (!Number.isFinite(pending.at) || Date.now() - pending.at > 1800000 || pending.at > Date.now())) {
    try { window.sessionStorage.removeItem('outerReefPendingInquiry'); } catch (error) { /* Storage unavailable. */ }
    pending = null;
  }
  if (contactSucceeded && pending && pending.path === window.location.pathname && pending.fields && pending.fields.email) {
    // No tracking cookie is attached: a shared browser must not merge different
    // people's contact identities. No marketing opt-in is inferred from an inquiry.
    fetch('https://api.hsforms.com/submissions/v3/integration/submit/247327075/93d08372-da91-45de-9a3c-134c80eb683c', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ submittedAt: String(pending.at),
        fields: ['email', 'firstname', 'lastname', 'company', 'phone', 'message', 'original_landing_page', 'original_source', 'original_medium', 'original_campaign', 'service_line', 'lead_type'].filter(function (key) { return Boolean(pending.fields[key]); }).map(function (key) {
          return { objectTypeId: '0-1', name: key, value: pending.fields[key] };
        }), context: { pageUri: window.location.origin + pending.path, pageName: document.title.slice(0, 200) }
      })
    }).then(function (response) {
      if (response.ok) { try { window.sessionStorage.removeItem('outerReefPendingInquiry'); } catch (error) { /* Storage unavailable. */ } }
    }).catch(function () { /* The accepted inquiry remains in Shopify; retry is possible on reload within 30 minutes. */ });
  }
  var countConversion = contactSucceeded && pending && pending.path === window.location.pathname;
  if (countConversion) {
    try {
      var receipt = String(pending.at);
      if (window.sessionStorage.getItem('outerReefInquiryReceipt') === receipt) countConversion = false;
      else window.sessionStorage.setItem('outerReefInquiryReceipt', receipt);
    } catch (error) { /* Per-page deduplication still applies when storage is unavailable. */ }
  }
  if (countConversion) {
    var line = serviceLine();
    sendOnce('generate_lead', window.location.pathname, {
      service_line: line,
      form_location: window.location.pathname
    });
    if (line === 'recruiting') {
      sendOnce('recruiting_inquiry', window.location.pathname, {
        recruiting_audience: recruitingAudience(),
        form_location: window.location.pathname
      });
    }
  }
}());
